import { useState } from 'react';
import api from '../lib/api';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { toast } from 'sonner';
import { Key } from 'lucide-react';
import PasswordInput from './PasswordInput';

export default function ChangePasswordModal({ open, onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!currentPassword || !newPassword) { toast.error('All fields are required'); return; }
    if (newPassword.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (newPassword !== confirmPassword) { toast.error('Passwords do not match'); return; }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { current_password: currentPassword, new_password: newPassword });
      toast.success('Password changed successfully');
      setCurrentPassword(''); setNewPassword(''); setConfirmPassword('');
      onClose();
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed to change password'); }
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-white rounded-sm border-[#E5E0D8]">
        <DialogHeader>
          <DialogTitle className="font-serif text-lg flex items-center gap-2"><Key size={18} className="text-[#C5A059]" />Change Password</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label className="text-[10px] tracking-[0.15em] uppercase font-semibold text-[#1A1A1A] mb-2 block">Current Password</Label>
            <PasswordInput value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="rounded-sm border-[#E5E0D8]" data-testid="current-password-input" />
          </div>
          <div>
            <Label className="text-[10px] tracking-[0.15em] uppercase font-semibold text-[#1A1A1A] mb-2 block">New Password</Label>
            <PasswordInput value={newPassword} onChange={e => setNewPassword(e.target.value)} className="rounded-sm border-[#E5E0D8]" data-testid="new-password-input" placeholder="Minimum 6 characters" />
          </div>
          <div>
            <Label className="text-[10px] tracking-[0.15em] uppercase font-semibold text-[#1A1A1A] mb-2 block">Confirm New Password</Label>
            <PasswordInput value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="rounded-sm border-[#E5E0D8]" data-testid="confirm-password-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm border-[#E5E0D8]">Cancel</Button>
          <Button onClick={handleSubmit} disabled={saving} className="bg-[#C5A059] hover:bg-[#B38F48] text-white rounded-sm" data-testid="change-password-btn">
            {saving ? 'Changing...' : 'Change Password'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
